import { Api } from '@/common/utils';

export const getGeneralMetaData = async () => {
  const { data } = await Api.request({
    url: '/metadata/general',
    auth: false,
  });

  return data;
};
